export default __webpack_public_path__ + "static/media/orderDetailsCart.4b958f4c.svg";